<template>
  <div class="game-menu">
    <div class="game-owner">
      <b-button
        v-for="(item, index) in Product(categoryId)"
        :key="item.id"
        :class="
          `game-group game-ower-logo product_${item.Id} ` +
          (ProductId == item.Id ? 'nuxt-link-active' : '')
        "
        @click="ProductHref(item.Id)"
      >
        <div class="game-new"><i class="icon icon-new"></i></div>
        <div class="game-soon">
          <b>
            {{ $t("store.soon1") }}
            <q>{{ $t("store.soon2") }}</q>
            <q>{{ $t("store.soon3") }}</q>
            {{ $t("store.soon4") }}
          </b>
        </div>
        <i></i>
        <span>{{ item.GameName }}</span>
      </b-button>
    </div>
    <ul class="game-type">
      <li>
        <a
          href="#"
          :class="ClassificationId == 0 ? 'nuxt-link-active' : ''"
          @click="ClassificationClick(0)"
        >
          {{ $t("store.all_games") }}
        </a>
      </li>
      <li v-for="(type, index) in GameClassification">
        <a
          href="#"
          :class="ClassificationId == type.value ? 'nuxt-link-active' : ''"
          @click="ClassificationClick(type.value)"
        >
          {{ type.text }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  props: {
    categoryId: { type: Number, default: 3 },
  },
  data() {
    return {};
  },
  methods: {
    init() {
      if (this.QueryProductId)
        this.ProductClick(this.QueryProductId);
      else
        this.ProductClick(this.Product(this.categoryId)[0].Id);
    },
    ProductHref(ProductId) {
      this.$router.push({ name: 'game-egame', params: undefined, query: { ProductId }});
    },
    ProductClick(id) {
      this.setProductId(id);
    },
    ClassificationClick(id) {
      this.setClassificationId(id);
    },
    ...mapActions("game", ["getGameClassification", "getGameList"]),
    ...mapMutations("game", ["setProductId", "setClassificationId", "setTableSettingCurrent"])
  },
  mounted() {
    this.init();
  },
  watch: {
    ProductId(value) {
      this.getGameClassification();
      this.setTableSettingCurrent(1);
      this.$nextTick(() => {
        if (this.ClassificationId != 0) this.ClassificationClick(0);
        else this.getGameList();
      });
    },
    ClassificationId(value) {
      this.setTableSettingCurrent(1);
      this.$nextTick(() => this.getGameList());
    },
    "$route.query.ProductId"(ProductId) {
      let ProductData = this.Product(this.categoryId).find((element) => parseInt(element.Id) === parseInt(this.$route.query.ProductId));
      this.ProductClick(ProductData ? ProductData.Id : this.Product(this.categoryId)[0].Id);
    },
  },
  computed: {
    QueryProductId: function () {
      let ProductData = this.Product(this.categoryId).find((element) => parseInt(element.Id) === parseInt(this.$route.query.ProductId));
      let ProductId   = ProductData ? ProductData.Id : this.Product(this.categoryId)[0].Id;
      return ProductId;
    },
    ...mapState("game", ["ProductId", "ClassificationId", "GameSelect", "GameList"]),
    ...mapGetters(["Product"]),
    ...mapGetters("game", ["GameClassification"]),
  },
};
</script>